import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import EditIcon from "../../../../assets/icons/edit.svg"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"

const BucketEditMenu = (props: any) => {

    const { anchorEl, setAnchorEl, selectedTab, index, value, bucketId, handleBucketUpdateOpen, handleBucketDeleteOpen } = props

    const openMenu = Boolean(anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickEdit = () => {
        handleBucketUpdateOpen(value, bucketId)
        handleClose();
    }

    const handleClickDelete = () => {
        handleBucketDeleteOpen(value, bucketId);
        handleClose();
    }

    return (
        <Box>
            <IconButton
                id="basic-button"
                aria-controls={openMenu ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
                onClick={handleClick}
                sx={{ display: "flex", height: "100%", alignItems: "center", color: selectedTab === index ? "black" : "white" }}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                sx={{ padding: "0 !important" }}
            >
                <MenuItem sx={{ display: "flex", width: "100%", justifyContent: "space-around", padding: "5px 0" }} onClick={() => handleClickEdit()}>
                    <EditIcon sx={{ cursor: "pointer" }} />
                    <Typography>
                        Edit
                    </Typography>
                </MenuItem>
                <MenuItem sx={{ display: "flex", width: "100px", justifyContent: "space-around", padding: "5px 0" }} onClick={() => handleClickDelete()}>
                    <DeleteIcon sx={{ cursor: "pointer" }} />
                    <Typography>
                        Delete
                    </Typography>
                </MenuItem>
            </Menu>
        </Box>
    )
}

export default BucketEditMenu